<template>
    <div>
        <!-- Campo di ricerca -->
        <div class="mb-3">
            <label class="form-label">Cerca Icona</label>
            <input type="text" v-model="filtroIcona" class="form-control form-control-sm" placeholder="Es: star, heart, bell..." />
        </div>

        <!-- Icone -->
        <div class="mb-3">
            <label class="form-label">Icona</label>
            <div class="d-flex flex-wrap gap-2" style="max-height: 240px; overflow-y: auto;">
                <div v-for="icona in iconeFiltrate" :key="icona" :class="['box-icona', modello.ICONA === icona ? 'selezionata' : '']" @click="modello.ICONA = modello.ICONA === icona ? '' : icona">
                    <i :class="['fa', icona]"></i>
                </div>
            </div>
        </div>

        <!-- Colore -->
        <div class="mb-3">
            <label class="form-label">Colore</label>
            <input type="color" v-model="modello.COLORE" class="form-control form-control-color" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconaColoreSelettore',

    props: {
        modelValue: {
            type: Object,
            required: true,
        },

        iconeDisponibili: {
            type: Array,
            default: () => [
                'fa-star', 'fa-heart', 'fa-bolt', 'fa-check', 'fa-user', 'fa-lock',
                'fa-book', 'fa-calendar', 'fa-camera', 'fa-briefcase', 'fa-bell',
                'fa-cog', 'fa-envelope', 'fa-globe', 'fa-graduation-cap',
                'fa-lightbulb', 'fa-magic', 'fa-music', 'fa-play', 'fa-plus',
                'fa-question', 'fa-rocket', 'fa-save', 'fa-search', 'fa-smile',
                'fa-tag', 'fa-tasks', 'fa-thumbs-up', 'fa-trash', 'fa-tree', 'fa-unlock',
                'fa-home', 'fa-comments', 'fa-download', 'fa-upload', 'fa-chart-bar',
                'fa-list', 'fa-bars', 'fa-edit', 'fa-folder', 'fa-file', 'fa-paperclip',
                'fa-paper-plane', 'fa-sync', 'fa-wifi', 'fa-phone', 'fa-image'
            ],
        },
    },

    data() {
        return {
            filtroIcona: '',
        };
    },

    computed: {

        modello: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        },
        iconeFiltrate() {
            const filtro = this.filtroIcona.toLowerCase();
            return this.iconeDisponibili.filter(icona => icona.includes(filtro));
        },
    },

};
</script>

<style scoped>
.box-icona {
    width: 50px;
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 0.5rem;
    background-color: #f9f9f9;
    color: #555;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.box-icona:hover {
    background-color: #e2e6ea;
    border-color: #aaa;
}

.box-icona.selezionata {
    background-color: #0d6efd;
    border-color: #0d6efd;
    color: #fff;
}

.box-icona i {
    font-size: 1.2rem;
}
</style>
